<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<div class="container-size">
    <div *ngIf="selectedCustomer$ | async as selectedCustomer">
        <div class="row">
            <div class="col-md-9">
                <div class="d-flex align-items-center">
                    <h3
                            [disabled]="tooltipsAreDisabled"
                            [showDelay]="2000"
                            class="customer-title mr-4"
                            position="bottom"
                            suiTooltip
                            tooltipText="{{ selectedCustomer.name }}"
                    >
                        <strong>{{ selectedCustomer.name }}</strong>
                    </h3>
                    <winde-ctx-sensitive-help
                            *windeHasAnyAuthority="userAuthorities.ALL_SIKLU"
                            [hidden]="baseUrl !== 'customers'"
                            placement="bottom"
                            tooltipTextPath="customer.details.btn.edit"
                    >
                        <button
                                [replaceUrl]="true"
                                [routerLink]="[{ outlets: { popup: [action.EDIT, 'customer', selectedCustomer.id] } }]"
                                queryParamsHandling="preserve"
                                windeActionIcon
                        >
                            <sui-svg-icon icon="pencil" windeOrange/>
                        </button>
                    </winde-ctx-sensitive-help>
                    <winde-ctx-sensitive-help
                            *windeHasAnyAuthority="userAuthorities.ALL_SIKLU"
                            [hidden]="baseUrl !== 'customers'"
                            placement="bottom"
                            tooltipTextPath="customer.details.btn.remove"
                    >
                        <button
                                [replaceUrl]="true"
                                [routerLink]="[{ outlets: { popup: [action.DELETE, 'customer', selectedCustomer.id] } }]"
                                queryParamsHandling="preserve"
                                windeActionIcon
                        >
                            <sui-svg-icon icon="cross" windeRed/>
                        </button>
                    </winde-ctx-sensitive-help>
                    <winde-ctx-sensitive-help
                            *windeHasAnyAuthority="userAuthorities.ALL_SIKLU"
                            [hidden]="baseUrl !== 'customers'"
                            placement="bottom"
                            tooltipTextPath="customer.details.btn.block"
                    >
                        <button
                                [replaceUrl]="true"
                                [routerLink]="[{ outlets: { popup: [action.BLOCK, 'customer', selectedCustomer.id] } }]"
                                queryParamsHandling="preserve"
                                windeActionIcon
                        >
                            <sui-svg-icon
                                    [ngClass]="{ blocked: selectedCustomer.blocked }"
                                    class="block-customer-button"
                                    icon="block"
                                    windeRed
                            />
                        </button>
                    </winde-ctx-sensitive-help>
                    <winde-ctx-sensitive-help
                            *windeHasAnyAuthority="userAuthorities.ALL_SIKLU"
                            [hidden]="baseUrl !== 'customers'"
                            placement="bottom"
                            tooltipTextPath="customer.details.btn.addUser"
                    >
                        <button
                                [replaceUrl]="true"
                                [routerLink]="['', { outlets: { popup: [action.CREATE, 'customers', selectedCustomer.id] } }]"
                                queryParamsHandling="preserve"
                                windeActionIcon
                        >
                            <sui-svg-icon class="add-user-button" icon="user-plus" windeGreen/>
                        </button>
                    </winde-ctx-sensitive-help>
                </div>
            </div>
            <div class="col-md-3">
                <div class="d-flex float-right align-items-center" style="height: 100%">
                    <div class="d-inline-flex justify-content-end customer-details-info">
                        <winde-ctx-sensitive-help placement="left" tooltipTextPath="customer.details.info.numberOfUsers">
                            <button windeTransparent>
                                <sui-svg-icon icon="users" windeGrey/>
                                <span> - {{ selectedCustomer.numberOfUsers }}</span>
                            </button>
                        </winde-ctx-sensitive-help>
                        <winde-ctx-sensitive-help placement="left" tooltipTextPath="customer.details.info.numberOfProjects">
                            <button windeTransparent>
                                <sui-svg-icon icon="briefcase" windeGrey/>
                                <span> - {{ selectedCustomer.numberOfProjects }} </span>
                            </button>
                        </winde-ctx-sensitive-help>
                    </div>
                </div>
            </div>
            <div class="clr"></div>
            <div class="col-6">
                <div class="col--location">
                    <h6 class="d-inline align-middle">Company Location:&nbsp;</h6>
                    <strong class="company-location align-middle">{{ selectedCustomer.location.name }}</strong>
                </div>

                @if (selectedCustomer?.sikluCompany) {
                    <div class="col--parent siklu-company">
                        <h6 class="d-inline align-middle">Siklu Company:</h6>
                        <button windeActionIcon>
                            <sui-svg-icon icon="check-bold" windeGrey/>
                        </button>
                    </div>
                }

                @if (selectedCustomer?.parentCompany) {
                    <div class="col--parent">
                        <h6 class="d-inline align-middle">Parent Company:&nbsp;</h6>
                        <strong class="company-parent align-middle">{{ selectedCustomer.parentCompany.name }}</strong>
                    </div>
                }

                @if (selectedCustomer?.childCompanies?.length) {
                    <div class="col--child">
                        <h6 class="d-inline align-middle">Child Companies:&nbsp;</h6>
                        <strong class="company-child align-middle">{{ getChildCompaniesNames(selectedCustomer) }}</strong>
                    </div>
                }

                <div class="col--sales">
                    <h6 class="d-inline align-middle">Company Sales:</h6>
                    <div *ngIf="selectedCustomer.sales && selectedCustomer.sales.length > 0" class="d-inline font-weight-normal">
                        <ul class="d-inline list-unstyled list-inline list-inline--comma mb-0 ml-1 align-middle">
                            <li *ngFor="let sale of selectedCustomer.sales.slice(0, 4)">
                                {{ sale.login }}
                            </li>
                        </ul>
                        <span *ngIf="selectedCustomer.sales && selectedCustomer.sales.length > 4" class="sales-list-dots">...</span>
                    </div>
                    <strong *ngIf="!selectedCustomer.sales || selectedCustomer.sales.length === 0">Not yet selected</strong>
                </div>
            </div>
            <div class="col-6">
                <div class="col--design-timeout">
                    <h6 class="d-inline">Design Weeks Timeout:</h6>
                    <strong *ngIf="selectedCustomer.designBomDaysTimeout" class="align-middle">
                        {{ selectedCustomer.designBomDaysTimeout / 7 }}
                        <span *ngIf="selectedCustomer.designBomDaysTimeout / 7 < 2">week</span>
                        <span *ngIf="selectedCustomer.designBomDaysTimeout / 7 >= 2">weeks</span>
                    </strong>
                    <strong *ngIf="!selectedCustomer.designBomDaysTimeout">&nbsp;None</strong>
                </div>
                <div class="col--bom-timeout">
                    <h6 class="d-inline">BOM Export Weeks Timeout:</h6>
                    <strong *ngIf="selectedCustomer.bomExportDaysTimeout" class="align-middle">
                        {{ selectedCustomer.bomExportDaysTimeout / 7 }}
                        <span *ngIf="selectedCustomer.bomExportDaysTimeout / 7 < 2">week</span>
                        <span *ngIf="selectedCustomer.bomExportDaysTimeout / 7 >= 2">weeks</span>
                    </strong>
                    <strong *ngIf="!selectedCustomer.bomExportDaysTimeout">&nbsp;None</strong>
                </div>
            </div>
        </div>
    </div>
</div>
